var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgECommerceDemo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    height: 1498,
    viewBox: "0 0 1366 1498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_152",
    x: 1221,
    y: 9,
    width: 71,
    height: 71,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.031
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_638",
    x: 1082,
    y: 9,
    width: 152,
    height: 71,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.031
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a3201b1946f61035d62c3581f2e628ec",
    x: 1280,
    y: 9,
    width: 71,
    height: 71,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.031
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_653",
    x: 473,
    y: 325,
    width: 879,
    height: 357,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_652",
    x: 91,
    y: 325,
    width: 382,
    height: 357,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_355",
    x: 91,
    y: 245,
    width: 633,
    height: 79,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1272",
    x: 723,
    y: 245,
    width: 633,
    height: 79,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_355-2",
    x: 789,
    y: 773,
    width: 563,
    height: 442,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_462",
    x: 91,
    y: 773,
    width: 698,
    height: 442,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_679",
    x: 91,
    y: 1295.5,
    width: 1264.813,
    height: 182,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_01_E-Commerce_-_Chiffres_Cl\\xE9s_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 1498
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01_E-Commerce_-_Chiffres_Cl\\xE9s_1",
    "data-name": "01_E-Commerce - Chiffres Cl\\xE9s \\u2013 1",
    clipPath: "url(#clip-_01_E-Commerce_-_Chiffres_Cl\\xE9s_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 1498,
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "CHIFFRE_D_AFFAIRES",
    "data-name": "CHIFFRE D\\u2019AFFAIRES",
    transform: "translate(106 212)",
    fill: "#101221",
    fontSize: 25,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CHIFFRE D\u2019AFFAIRES")), /*#__PURE__*/React.createElement("text", {
    id: "VENTILLATION_DES_VENTES",
    "data-name": "VENTILLATION DES VENTES",
    transform: "translate(106 737)",
    fill: "#101221",
    fontSize: 25,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VENTILLATION DES VENTES")), /*#__PURE__*/React.createElement("text", {
    id: "PANIERS_ABANDONN\\xC9S",
    "data-name": "PANIERS ABANDONN\\xC9S",
    transform: "translate(106 1264.896)",
    fill: "#101221",
    fontSize: 25,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PANIERS ABANDONN\xC9S")), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_739",
    "data-name": "Groupe 739",
    transform: "translate(-168)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Bonjour_Arthur_",
    "data-name": "Bonjour Arthur !",
    transform: "translate(274 40)",
    fill: "#101221",
    fontSize: 20,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bonjour Arthur !")), /*#__PURE__*/React.createElement("text", {
    id: "La_curiosit\\xE9_ne_se_force_pas_elle_s_\\xE9veille_",
    "data-name": "La curiosit\\xE9 ne se force pas, elle s\\u2019\\xE9veille\\u2026",
    transform: "translate(274 64)",
    fill: "#b1b5bc",
    fontSize: 14,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "La curiosit\xE9 ne se force pas, elle s\u2019\xE9veille\u2026")), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\uD83D\\uDC4B",
    transform: "translate(568 64)",
    fill: "#707070",
    fontSize: 13,
    fontFamily: "AppleColorEmoji, Apple Color Emoji"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD83D\uDC4B"))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_239",
    "data-name": "Groupe 239",
    transform: "translate(-138 92)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 1230,
    height: 60,
    rx: 10,
    transform: "translate(244)",
    fill: "#1b7afa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_today_24px",
    d: "M13.943,2.368h-.684V1H11.891V2.368H6.42V1H5.052V2.368H4.368A1.362,1.362,0,0,0,3.007,3.736L3,13.311a1.367,1.367,0,0,0,1.368,1.368h9.575a1.372,1.372,0,0,0,1.368-1.368V3.736A1.372,1.372,0,0,0,13.943,2.368Zm0,10.943H4.368V5.787h9.575Z",
    transform: "translate(1021.791 23.16)",
    fill: "#1b7afa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-down",
    "data-name": "Icon awesome-chevron-down",
    d: "M3.687,12.9.513,9.723a.392.392,0,0,1,0-.554l.37-.37a.392.392,0,0,1,.554,0l2.527,2.515L6.491,8.8a.392.392,0,0,1,.554,0l.37.37a.392.392,0,0,1,0,.554L4.241,12.9A.392.392,0,0,1,3.687,12.9Z",
    transform: "translate(1290.037 20.152)",
    fill: "#1b7afa"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Source",
    transform: "translate(725.5 128)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Source")), /*#__PURE__*/React.createElement("text", {
    id: "Support",
    transform: "translate(933.5 128)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Support")), /*#__PURE__*/React.createElement("text", {
    id: "Campagne",
    transform: "translate(1143.5 128)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Campagne")), /*#__PURE__*/React.createElement("text", {
    id: "E-COMMERCE",
    transform: "translate(170.883 127.629)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E-COMMERCE")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-down-2",
    "data-name": "Icon awesome-chevron-down",
    d: "M3.686,8.8.512,11.972a.392.392,0,0,0,0,.554l.37.37a.392.392,0,0,0,.554,0l2.527-2.515L6.49,12.9a.392.392,0,0,0,.554,0l.37-.37a.392.392,0,0,0,0-.554L4.24,8.8A.392.392,0,0,0,3.686,8.8Z",
    transform: "translate(1101.898 133.348) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-down-3",
    "data-name": "Icon awesome-chevron-down",
    d: "M3.686,8.8.512,11.972a.392.392,0,0,0,0,.554l.37.37a.392.392,0,0,0,.554,0l2.527-2.515L6.49,12.9a.392.392,0,0,0,.554,0l.37-.37a.392.392,0,0,0,0-.554L4.24,8.8A.392.392,0,0,0,3.686,8.8Z",
    transform: "translate(1310.898 133.348) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-down-4",
    "data-name": "Icon awesome-chevron-down",
    d: "M3.686,8.8.512,11.972a.392.392,0,0,0,0,.554l.37.37a.392.392,0,0,0,.554,0l2.527-2.515L6.49,12.9a.392.392,0,0,0,.554,0l.37-.37a.392.392,0,0,0,0-.554L4.24,8.8A.392.392,0,0,0,3.686,8.8Z",
    transform: "translate(892.898 133.348) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_227",
    "data-name": "Ligne 227",
    x2: 167,
    transform: "translate(1144 137.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_228",
    "data-name": "Ligne 228",
    x2: 167,
    transform: "translate(934.5 137.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_229",
    "data-name": "Ligne 229",
    x2: 167,
    transform: "translate(725.002 137.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_301",
    "data-name": "Groupe 301",
    transform: "translate(1236 24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1236, -24)",
    filter: "url(#Ellipse_152)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152-2",
    "data-name": "Ellipse 152",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(1236 24)",
    fill: "#939495"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic_email_24px",
    d: "M16.625,4h-13A1.623,1.623,0,0,0,2.008,5.625L2,15.375A1.63,1.63,0,0,0,3.625,17h13a1.63,1.63,0,0,0,1.625-1.625V5.625A1.63,1.63,0,0,0,16.625,4Zm0,3.25-6.5,4.063L3.625,7.25V5.625l6.5,4.063,6.5-4.063Z",
    transform: "translate(10.375 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_300",
    "data-name": "Groupe 300",
    transform: "translate(1096.898 24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1096.9, -24)",
    filter: "url(#Rectangle_638)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638-2",
    "data-name": "Rectangle 638",
    width: 122,
    height: 41,
    rx: 10,
    transform: "translate(1097 24)",
    fill: "#939495"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Exporter",
    transform: "translate(41.101 26)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Exporter")), /*#__PURE__*/React.createElement("path", {
    id: "ic_file_download_24px",
    d: "M18.7,8.872H14.786V3H8.914V8.872H5l6.85,6.85ZM5,17.679v1.957H18.7V17.679Z",
    transform: "translate(9.139 9.365)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_302",
    "data-name": "Groupe 302",
    transform: "translate(1295 24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1295, -24)",
    filter: "url(#a3201b1946f61035d62c3581f2e628ec)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "a3201b1946f61035d62c3581f2e628ec-2",
    "data-name": "a3201b1946f61035d62c3581f2e628ec",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(1295 24)",
    fill: "#101221"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M7.5,8.438A4.219,4.219,0,1,0,3.281,4.219,4.22,4.22,0,0,0,7.5,8.438Zm3.75.938H9.636a5.1,5.1,0,0,1-4.271,0H3.75A3.75,3.75,0,0,0,0,13.125v.469A1.407,1.407,0,0,0,1.406,15H13.594A1.407,1.407,0,0,0,15,13.594v-.469A3.75,3.75,0,0,0,11.25,9.375Z",
    transform: "translate(13 13)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic_today_24px-2",
    "data-name": "ic_today_24px",
    d: "M22.872,3.484H21.63V1H19.146V3.484H9.21V1H6.726V3.484H5.484A2.473,2.473,0,0,0,3.012,5.968L3,23.356A2.483,2.483,0,0,0,5.484,25.84H22.872a2.491,2.491,0,0,0,2.484-2.484V5.968A2.491,2.491,0,0,0,22.872,3.484Zm0,19.872H5.484V9.694H22.872Z",
    transform: "translate(791.211 28)",
    fill: "#101221"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_5_mai_2022_-_17_mai_2022",
    "data-name": "5 mai 2022 - 17 mai 2022",
    transform: "translate(843 48)",
    fill: "#101221",
    fontSize: 14,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5 mai 2022 - 17 mai 2022")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-down-5",
    "data-name": "Icon awesome-chevron-down",
    d: "M3.687,12.9.513,9.723a.392.392,0,0,1,0-.554l.37-.37a.392.392,0,0,1,.554,0l2.527,2.515L6.491,8.8a.392.392,0,0,1,.554,0l.37.37a.392.392,0,0,1,0,.554L4.241,12.9A.392.392,0,0,1,3.687,12.9Z",
    transform: "translate(1058.037 32.152)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_234",
    "data-name": "Ligne 234",
    x2: 277,
    transform: "translate(788.5 66.5)",
    fill: "none",
    stroke: "#101221",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_476",
    "data-name": "Ligne 476",
    y1: 0.164,
    x2: 949.313,
    transform: "translate(391.5 211.336)",
    fill: "none",
    stroke: "#101221",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_547",
    "data-name": "Ligne 547",
    y1: 0.164,
    x2: 865.313,
    transform: "translate(475.5 736.336)",
    fill: "none",
    stroke: "#101221",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_548",
    "data-name": "Ligne 548",
    y1: 0.268,
    x2: 903.313,
    transform: "translate(437.5 1264.232)",
    fill: "none",
    stroke: "#101221",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_738",
    "data-name": "Groupe 738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1241",
    "data-name": "Rectangle 1241",
    fill: "#101221",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 2728,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 75,
    height: 2727,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    transform: "translate(10 20)",
    fill: "#fff",
    stroke: "#d9d9d9",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 56.5,
    height: 56.5,
    rx: 9.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_194",
    "data-name": "Ligne 194",
    x2: 39,
    transform: "translate(18.5 168.5)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_195",
    "data-name": "Ligne 195",
    x2: 39,
    transform: "translate(18.5 247.5)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_236",
    "data-name": "Ligne 236",
    x2: 39,
    transform: "translate(18.5 334.5)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_237",
    "data-name": "Ligne 237",
    x2: 39,
    transform: "translate(18.5 418.5)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_238",
    "data-name": "Ligne 238",
    x2: 39,
    transform: "translate(18.5 1040.5)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_239",
    "data-name": "Ligne 239",
    x2: 39,
    transform: "translate(18.5 1512.5)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_240",
    "data-name": "Ligne 240",
    x2: 39,
    transform: "translate(18.5 1698.5)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_dashboard_24px",
    d: "M3,13h8V3H3Zm0,8h8V15H3Zm10,0h8V11H13ZM13,3V9h8V3Z",
    transform: "translate(26 115)",
    fill: "#a7adbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 1.863,
    height: 5.587,
    transform: "translate(36.926 31.145)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 1.863,
    height: 5.587,
    transform: "translate(36.926 59.27)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 5.587,
    height: 1.863,
    transform: "translate(49.125 47.07)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 5.587,
    height: 1.863,
    transform: "translate(21 47.07)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 5.587,
    height: 1.863,
    transform: "translate(45.166 39.373) rotate(-45)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 5.587,
    height: 1.863,
    transform: "translate(25.277 59.262) rotate(-45)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 1.863,
    height: 5.587,
    transform: "translate(45.166 56.629) rotate(-45)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 1.863,
    height: 5.587,
    transform: "translate(25.277 36.74) rotate(-45)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 5.587,
    height: 1.864,
    transform: "matrix(0.394, -0.919, 0.919, 0.394, 40.215, 40.09)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 5.587,
    height: 1.864,
    transform: "translate(31.586 60.229) rotate(-66.804)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M146.629,116.992l-5.135-2.2.734-1.714,5.135,2.2Z",
    transform: "translate(-96.504 -62.76)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M27.859,66.1l-5.134-2.2.734-1.714,5.135,2.2Z",
    transform: "translate(2.129 -20.494)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 5.588,
    height: 1.863,
    transform: "translate(45.086 44.064) rotate(-21.807)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 5.588,
    height: 1.863,
    transform: "translate(24.748 52.201) rotate(-21.807)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M114.274,147.7l-2.074-5.187,1.73-.692L116,147.008Z",
    transform: "translate(-72.176 -86.631)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M66.275,27.729,64.2,22.542l1.73-.692L68,27.038Z",
    transform: "translate(-32.314 12.998)",
    fill: "#cb4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_timeline_24px",
    d: "M26.667,8.333a2.34,2.34,0,0,1-2.333,2.333,1.983,1.983,0,0,1-.6-.082l-4.153,4.142a2.061,2.061,0,0,1,.082.607,2.333,2.333,0,0,1-4.667,0,2.061,2.061,0,0,1,.082-.607l-2.975-2.975a2.294,2.294,0,0,1-1.213,0l-5.308,5.32a1.983,1.983,0,0,1,.082.595,2.333,2.333,0,1,1-2.333-2.333,1.983,1.983,0,0,1,.6.082l5.32-5.308A2.061,2.061,0,0,1,9.167,9.5a2.333,2.333,0,1,1,4.667,0,2.061,2.061,0,0,1-.082.607l2.975,2.975a2.294,2.294,0,0,1,1.213,0l4.142-4.153a1.983,1.983,0,0,1-.082-.6,2.333,2.333,0,0,1,4.667,0Z",
    transform: "translate(24 195)",
    fill: "#35c0fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_338",
    "data-name": "Groupe 338",
    transform: "translate(28 451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_391",
    "data-name": "Trac\\xE9 391",
    d: "M253.68,52.257V44.133a.436.436,0,0,1,.044-.243.355.355,0,0,1,.243-.11,21.748,21.748,0,0,0,9.581-4.106c.221-.177.441-.331.662-.508a.438.438,0,0,1,.773.375v17.2c0,.4-.221.618-.508.53a.927.927,0,0,1-.309-.2c-.949-.729-1.877-1.5-2.87-2.163a16.928,16.928,0,0,0-7.44-2.627Z",
    transform: "translate(-246.99 -39.003)",
    fill: "#69e097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_392",
    "data-name": "Trac\\xE9 392",
    d: "M89.825,165.2v8.191l-.375.022c.066.221.11.464.177.684.287,1.016.574,2.031.861,3.024a1.62,1.62,0,1,1-3.091.971c0-.022-.022-.044-.022-.088-.419-1.479-.817-2.936-1.236-4.415a.375.375,0,0,0-.309-.309A2.459,2.459,0,0,1,84,170.895v-3.047a2.469,2.469,0,0,1,2.429-2.517h.044c.552,0,1.1,0,1.656-.044s1.126-.044,1.7-.088Z",
    transform: "translate(-83.996 -160.224)",
    fill: "#69e097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_393",
    "data-name": "Trac\\xE9 393",
    d: "M562.24,198.822V192.64a3.284,3.284,0,0,1,2.12,2.87,3.338,3.338,0,0,1-2.12,3.312Z",
    transform: "translate(-543.386 -186.583)",
    fill: "#69e097"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-down-6",
    "data-name": "Icon awesome-chevron-down",
    d: "M4.512,5.782.158,1.426a.538.538,0,0,1,0-.761L.665.158a.538.538,0,0,1,.76,0L4.893,3.609,8.36.157a.538.538,0,0,1,.76,0l.508.508a.538.538,0,0,1,0,.761L5.273,5.782A.538.538,0,0,1,4.512,5.782Z",
    transform: "translate(35.193 2548.785) rotate(-90)",
    fill: "#e2e2ea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    transform: "translate(18 2524)",
    fill: "none",
    stroke: "#e2e2ea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-store",
    "data-name": "Icon awesome-store",
    d: "M25.414,5.007,22.675.633A1.351,1.351,0,0,0,21.531,0H4.476A1.351,1.351,0,0,0,3.332.633L.593,5.007a3.766,3.766,0,0,0,2.482,5.758,4.387,4.387,0,0,0,.578.038,4.168,4.168,0,0,0,3.115-1.4,4.172,4.172,0,0,0,6.231,0,4.172,4.172,0,0,0,6.231,0,4.182,4.182,0,0,0,3.115,1.4,4.34,4.34,0,0,0,.578-.038A3.762,3.762,0,0,0,25.414,5.007Zm-3.061,7.151A5.356,5.356,0,0,1,21.109,12V16.21H4.9V12a5.592,5.592,0,0,1-1.245.16,5.7,5.7,0,0,1-.76-.051,5.309,5.309,0,0,1-.692-.152v8.308a1.349,1.349,0,0,0,1.351,1.351H22.464a1.349,1.349,0,0,0,1.351-1.351V11.955a4.31,4.31,0,0,1-.692.152A5.871,5.871,0,0,1,22.354,12.158Z",
    transform: "translate(24.996 280)",
    fill: "#aaefff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-instagram",
    d: "M8.091,3A5.1,5.1,0,0,0,3,8.094v7.274a5.1,5.1,0,0,0,5.094,5.091h7.274a5.1,5.1,0,0,0,5.091-5.094V8.091A5.1,5.1,0,0,0,15.365,3Zm8.731,2.91a.727.727,0,1,1-.727.727A.728.728,0,0,1,16.821,5.91ZM11.729,7.365a4.365,4.365,0,1,1-4.365,4.365A4.369,4.369,0,0,1,11.729,7.365Zm0,1.455a2.91,2.91,0,1,0,2.91,2.91,2.91,2.91,0,0,0-2.91-2.91Z",
    transform: "translate(26 797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-lecture-de-youtube",
    d: "M20.521,11.3a2.376,2.376,0,0,0-1.882-1.8A37.208,37.208,0,0,0,11.948,9a37.756,37.756,0,0,0-6.732.5,2.321,2.321,0,0,0-1.882,1.8A27.437,27.437,0,0,0,3,15.691a22.759,22.759,0,0,0,.376,4.391,2.38,2.38,0,0,0,1.882,1.8,38.468,38.468,0,0,0,6.733.5,38.468,38.468,0,0,0,6.733-.5,2.323,2.323,0,0,0,1.882-1.8,32.078,32.078,0,0,0,.418-4.391A29.262,29.262,0,0,0,20.521,11.3ZM9.691,18.618V12.764l5.1,2.927Z",
    transform: "translate(26 841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-twitter",
    d: "M18,5.975a6.553,6.553,0,0,1-1.885.517,3.288,3.288,0,0,0,1.443-1.816,6.582,6.582,0,0,1-2.085.8A3.283,3.283,0,0,0,9.794,7.718a3.319,3.319,0,0,0,.085.748,9.319,9.319,0,0,1-6.766-3.43A3.288,3.288,0,0,0,4.129,9.419a3.276,3.276,0,0,1-1.487-.41v.041a3.283,3.283,0,0,0,2.633,3.218,3.284,3.284,0,0,1-.865.115,3.342,3.342,0,0,1-.617-.058A3.286,3.286,0,0,0,6.859,14.6,6.624,6.624,0,0,1,2,15.964a9.293,9.293,0,0,0,5.032,1.474A9.275,9.275,0,0,0,16.37,8.1q0-.213-.009-.425A6.68,6.68,0,0,0,18,5.975Z",
    transform: "translate(28 750.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-google-ads_Test",
    transform: "translate(28 502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_389",
    "data-name": "Trac\\xE9 389",
    d: "M18.271,12.573,12.516,9.25,5.871,20.5l5.755,3.323Z",
    transform: "translate(-5.425 -7.595)",
    fill: "#fff",
    opacity: 0.317
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_390",
    "data-name": "Trac\\xE9 390",
    d: "M25.09,22.235a3.322,3.322,0,0,0,5.755-3.323L24.2,7.667a3.322,3.322,0,1,0-5.755,3.323Z",
    transform: "translate(-11.354 -6.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 3.35,
    cy: 3.352,
    rx: 3.35,
    ry: 3.352,
    transform: "translate(0 11.172)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-facebook",
    d: "M20.364,4H5.636A1.636,1.636,0,0,0,4,5.636V20.364A1.636,1.636,0,0,0,5.636,22h8.182V14.636H11.364V12.182h2.455V10.864c0-2.5,1.216-3.591,3.29-3.591a12.008,12.008,0,0,1,1.767.107V9.727H17.461c-.88,0-1.188.465-1.188,1.406v1.049h2.581l-.35,2.455h-2.23V22h4.091A1.636,1.636,0,0,0,22,20.364V5.636A1.636,1.636,0,0,0,20.364,4Z",
    transform: "translate(25 650)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-linkedin",
    d: "M20.364,4H5.636A1.636,1.636,0,0,0,4,5.636V20.364A1.636,1.636,0,0,0,5.636,22H20.364A1.636,1.636,0,0,0,22,20.364V5.636A1.636,1.636,0,0,0,20.364,4ZM9.69,18.727H7.276V10.961H9.69ZM8.458,9.851A1.407,1.407,0,1,1,9.865,8.444,1.407,1.407,0,0,1,8.458,9.851Zm10.272,8.876H16.319V14.951c0-.9-.016-2.059-1.254-2.059-1.256,0-1.449.981-1.449,1.994v3.842H11.2V10.961h2.315v1.061h.033a2.536,2.536,0,0,1,2.284-1.254c2.444,0,2.9,1.609,2.9,3.7v4.259Z",
    transform: "translate(25 700)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-tiktok",
    "data-name": "Icon simple-tiktok",
    d: "M8.58.011C9.323,0,10.061.006,10.8,0a3.533,3.533,0,0,0,.993,2.365A4,4,0,0,0,14.2,3.381V5.667a6.071,6.071,0,0,1-2.382-.55,7.008,7.008,0,0,1-.919-.528c-.006,1.656.006,3.313-.011,4.963a4.333,4.333,0,0,1-.766,2.235,4.226,4.226,0,0,1-3.352,1.821,4.136,4.136,0,0,1-2.314-.584,4.277,4.277,0,0,1-2.07-3.239c-.011-.284-.017-.567-.006-.845A4.27,4.27,0,0,1,7.327,5.15c.011.84-.023,1.679-.023,2.519a1.946,1.946,0,0,0-2.484,1.2,2.25,2.25,0,0,0-.079.913,1.931,1.931,0,0,0,1.985,1.628A1.906,1.906,0,0,0,8.3,10.5a1.309,1.309,0,0,0,.233-.6c.057-1.015.034-2.025.04-3.04.006-2.286-.006-4.566.011-6.846Z",
    transform: "translate(29.631 947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pinterest-square",
    "data-name": "Icon awesome-pinterest-square",
    d: "M17.98,4.176V18.3a1.927,1.927,0,0,1-1.926,1.926H6.2a10.284,10.284,0,0,0,1.1-2.38c.12-.462.614-2.344.614-2.344a2.635,2.635,0,0,0,2.26,1.132c2.974,0,5.113-2.733,5.113-6.129A5.784,5.784,0,0,0,9.207,4.819c-4.254,0-6.51,2.854-6.51,5.964a4.423,4.423,0,0,0,2,3.817c.189.088.285.048.329-.132.032-.136.2-.807.273-1.116a.291.291,0,0,0-.068-.281A3.842,3.842,0,0,1,4.5,10.823,4.266,4.266,0,0,1,8.946,6.544a3.892,3.892,0,0,1,4.118,4.009c0,2.665-1.345,4.511-3.1,4.511A1.433,1.433,0,0,1,8.5,13.283,19.916,19.916,0,0,0,9.319,10c0-2.127-3.03-1.834-3.03,1a3.6,3.6,0,0,0,.293,1.465c-1.26,5.33-1.449,5.4-1.188,7.73l.088.032H1.926A1.927,1.927,0,0,1,0,18.3V4.176A1.927,1.927,0,0,1,1.926,2.25H16.054A1.927,1.927,0,0,1,17.98,4.176Z",
    transform: "translate(29 893.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-snapchat-ghost",
    "data-name": "Icon awesome-snapchat-ghost",
    d: "M15.919,12.837c-.162.379-.849.657-2.1.851a5.845,5.845,0,0,0-.2.747.361.361,0,0,1-.378.276H13.23c-.293,0-.6-.135-1.211-.135a2.466,2.466,0,0,0-1.753.642,3.51,3.51,0,0,1-2.307.854,3.579,3.579,0,0,1-2.271-.854,2.463,2.463,0,0,0-1.753-.641,11.77,11.77,0,0,0-1.211.147.37.37,0,0,1-.387-.282,5.772,5.772,0,0,0-.2-.752c-.644-.1-2.1-.354-2.135-1a.331.331,0,0,1,.277-.345A4.691,4.691,0,0,0,3.463,9.665l.007-.016a.708.708,0,0,0,.077-.584c-.157-.371-.837-.5-1.124-.617-.739-.292-.842-.627-.8-.857a.8.8,0,0,1,1.028-.482,1.783,1.783,0,0,0,.734.2.636.636,0,0,0,.31-.068,9.3,9.3,0,0,1,.177-3.614A4.246,4.246,0,0,1,7.816,1.081l.315,0a4.216,4.216,0,0,1,3.949,2.544,9.3,9.3,0,0,1,.177,3.615.611.611,0,0,0,.268.067,1.862,1.862,0,0,0,.688-.195.843.843,0,0,1,.638,0h0a.647.647,0,0,1,.486.557c.006.3-.266.566-.806.78-.066.026-.146.052-.232.079-.305.1-.767.243-.892.538a.708.708,0,0,0,.077.584l.007.016a4.69,4.69,0,0,0,3.186,2.678A.34.34,0,0,1,15.919,12.837Z",
    transform: "translate(30 991.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Amazon_icon_1_",
    "data-name": "Amazon_icon (1)",
    transform: "translate(28.998 603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2142",
    "data-name": "Trac\\xE9 2142",
    d: "M20.2,191.715c-7.618,3.625-12.345.592-15.372-1.25-.187-.116-.506.027-.229.344a12.12,12.12,0,0,0,8.625,4.169,10.042,10.042,0,0,0,7.2-2.766c.319-.407.094-.632-.229-.5Zm2.139-1.182c-.2-.266-1.244-.316-1.9-.236s-1.638.478-1.553.719c.044.09.133.05.583.009s1.715-.2,1.979.14-.4,2-.525,2.265.045.335.266.158a3.455,3.455,0,0,0,.879-1.287,3.008,3.008,0,0,0,.269-1.768Z",
    transform: "translate(-4.488 -176.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2143",
    "data-name": "Trac\\xE9 2143",
    d: "M58.549,8.234a4.776,4.776,0,0,1-.457,2.589,1.98,1.98,0,0,1-1.69,1.109c-.938,0-1.484-.714-1.484-1.769,0-2.081,1.865-2.459,3.63-2.459Zm2.462,5.951a.51.51,0,0,1-.577.058,6.01,6.01,0,0,1-1.4-1.628,4.831,4.831,0,0,1-4.025,1.775,3.465,3.465,0,0,1-3.654-3.805,4.149,4.149,0,0,1,2.6-3.99,16.915,16.915,0,0,1,4.592-.848V5.431a3.142,3.142,0,0,0-.3-1.769,1.634,1.634,0,0,0-1.37-.635,1.861,1.861,0,0,0-1.964,1.466.511.511,0,0,1-.422.446l-2.37-.254a.433.433,0,0,1-.364-.512C52.309,1.3,54.9.438,57.223.438A5.536,5.536,0,0,1,60.9,1.654c1.188,1.109,1.075,2.589,1.075,4.2V9.659a3.34,3.34,0,0,0,.92,2.263.459.459,0,0,1-.007.649c-.5.416-1.384,1.188-1.872,1.621l-.007-.007",
    transform: "translate(-47.961 -0.438)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2144",
    "data-name": "Trac\\xE9 2144",
    d: "M20.2,191.715c-7.618,3.625-12.345.592-15.372-1.25-.187-.116-.506.027-.229.344a12.12,12.12,0,0,0,8.625,4.169,10.042,10.042,0,0,0,7.2-2.766c.319-.407.094-.632-.229-.5Zm2.139-1.182c-.2-.266-1.244-.316-1.9-.236s-1.638.478-1.553.719c.044.09.133.05.583.009s1.715-.2,1.979.14-.4,2-.525,2.265.045.335.266.158a3.455,3.455,0,0,0,.879-1.287,3.008,3.008,0,0,0,.269-1.768Z",
    transform: "translate(-4.488 -176.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2145",
    "data-name": "Trac\\xE9 2145",
    d: "M58.549,8.234a4.776,4.776,0,0,1-.457,2.589,1.98,1.98,0,0,1-1.69,1.109c-.938,0-1.484-.714-1.484-1.769,0-2.081,1.865-2.459,3.63-2.459Zm2.462,5.951a.51.51,0,0,1-.577.058,6.01,6.01,0,0,1-1.4-1.628,4.831,4.831,0,0,1-4.025,1.775,3.465,3.465,0,0,1-3.654-3.805,4.149,4.149,0,0,1,2.6-3.99,16.915,16.915,0,0,1,4.592-.848V5.431a3.142,3.142,0,0,0-.3-1.769,1.634,1.634,0,0,0-1.37-.635,1.861,1.861,0,0,0-1.964,1.466.511.511,0,0,1-.422.446l-2.37-.254a.433.433,0,0,1-.364-.512C52.309,1.3,54.9.438,57.223.438A5.536,5.536,0,0,1,60.9,1.654c1.188,1.109,1.075,2.589,1.075,4.2V9.659a3.34,3.34,0,0,0,.92,2.263.459.459,0,0,1-.007.649c-.5.416-1.384,1.188-1.872,1.621l-.007-.007",
    transform: "translate(-47.961 -0.438)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Microsoft_logo",
    transform: "translate(29 553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2147",
    "data-name": "Trac\\xE9 2147",
    d: "M1,1H9.218V9.218H1Z",
    transform: "translate(-1 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2148",
    "data-name": "Trac\\xE9 2148",
    d: "M12,1h8.218V9.218H12Z",
    transform: "translate(-2.96 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2149",
    "data-name": "Trac\\xE9 2149",
    d: "M1,12H9.218v8.218H1Z",
    transform: "translate(-1 -2.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2150",
    "data-name": "Trac\\xE9 2150",
    d: "M12,12h8.218v8.218H12Z",
    transform: "translate(-2.96 -2.96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic_share_24px",
    d: "M18,16.08a2.912,2.912,0,0,0-1.96.77L8.91,12.7A3.274,3.274,0,0,0,9,12a3.274,3.274,0,0,0-.09-.7l7.05-4.11A2.993,2.993,0,1,0,15,5a3.274,3.274,0,0,0,.09.7L8.04,9.81a3,3,0,1,0,0,4.38l7.12,4.16a2.821,2.821,0,0,0-.08.65A2.92,2.92,0,1,0,18,16.08Z",
    transform: "translate(26 1071)",
    fill: "#fd863a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-instagram-2",
    "data-name": "icons8-instagram",
    d: "M8.091,3A5.1,5.1,0,0,0,3,8.094v7.274a5.1,5.1,0,0,0,5.094,5.091h7.274a5.1,5.1,0,0,0,5.091-5.094V8.091A5.1,5.1,0,0,0,15.365,3Zm8.731,2.91a.727.727,0,1,1-.727.727A.728.728,0,0,1,16.821,5.91ZM11.729,7.365a4.365,4.365,0,1,1-4.365,4.365A4.369,4.369,0,0,1,11.729,7.365Zm0,1.455a2.91,2.91,0,1,0,2.91,2.91,2.91,2.91,0,0,0-2.91-2.91Z",
    transform: "translate(26 1269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-lecture-de-youtube-2",
    "data-name": "icons8-lecture-de-youtube",
    d: "M20.521,11.3a2.376,2.376,0,0,0-1.882-1.8A37.208,37.208,0,0,0,11.948,9a37.756,37.756,0,0,0-6.732.5,2.321,2.321,0,0,0-1.882,1.8A27.437,27.437,0,0,0,3,15.691a22.759,22.759,0,0,0,.376,4.391,2.38,2.38,0,0,0,1.882,1.8,38.468,38.468,0,0,0,6.733.5,38.468,38.468,0,0,0,6.733-.5,2.323,2.323,0,0,0,1.882-1.8,32.078,32.078,0,0,0,.418-4.391A29.262,29.262,0,0,0,20.521,11.3ZM9.691,18.618V12.764l5.1,2.927Z",
    transform: "translate(26 1313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-twitter-2",
    "data-name": "icons8-twitter",
    d: "M18,5.975a6.553,6.553,0,0,1-1.885.517,3.288,3.288,0,0,0,1.443-1.816,6.582,6.582,0,0,1-2.085.8A3.283,3.283,0,0,0,9.794,7.718a3.319,3.319,0,0,0,.085.748,9.319,9.319,0,0,1-6.766-3.43A3.288,3.288,0,0,0,4.129,9.419a3.276,3.276,0,0,1-1.487-.41v.041a3.283,3.283,0,0,0,2.633,3.218,3.284,3.284,0,0,1-.865.115,3.342,3.342,0,0,1-.617-.058A3.286,3.286,0,0,0,6.859,14.6,6.624,6.624,0,0,1,2,15.964a9.293,9.293,0,0,0,5.032,1.474A9.275,9.275,0,0,0,16.37,8.1q0-.213-.009-.425A6.68,6.68,0,0,0,18,5.975Z",
    transform: "translate(28 1222.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-facebook-2",
    "data-name": "icons8-facebook",
    d: "M20.364,4H5.636A1.636,1.636,0,0,0,4,5.636V20.364A1.636,1.636,0,0,0,5.636,22h8.182V14.636H11.364V12.182h2.455V10.864c0-2.5,1.216-3.591,3.29-3.591a12.008,12.008,0,0,1,1.767.107V9.727H17.461c-.88,0-1.188.465-1.188,1.406v1.049h2.581l-.35,2.455h-2.23V22h4.091A1.636,1.636,0,0,0,22,20.364V5.636A1.636,1.636,0,0,0,20.364,4Z",
    transform: "translate(25 1122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-linkedin-2",
    "data-name": "icons8-linkedin",
    d: "M20.364,4H5.636A1.636,1.636,0,0,0,4,5.636V20.364A1.636,1.636,0,0,0,5.636,22H20.364A1.636,1.636,0,0,0,22,20.364V5.636A1.636,1.636,0,0,0,20.364,4ZM9.69,18.727H7.276V10.961H9.69ZM8.458,9.851A1.407,1.407,0,1,1,9.865,8.444,1.407,1.407,0,0,1,8.458,9.851Zm10.272,8.876H16.319V14.951c0-.9-.016-2.059-1.254-2.059-1.256,0-1.449.981-1.449,1.994v3.842H11.2V10.961h2.315v1.061h.033a2.536,2.536,0,0,1,2.284-1.254c2.444,0,2.9,1.609,2.9,3.7v4.259Z",
    transform: "translate(25 1172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-tiktok-2",
    "data-name": "Icon simple-tiktok",
    d: "M8.58.011C9.323,0,10.061.006,10.8,0a3.533,3.533,0,0,0,.993,2.365A4,4,0,0,0,14.2,3.381V5.667a6.071,6.071,0,0,1-2.382-.55,7.008,7.008,0,0,1-.919-.528c-.006,1.656.006,3.313-.011,4.963a4.333,4.333,0,0,1-.766,2.235,4.226,4.226,0,0,1-3.352,1.821,4.136,4.136,0,0,1-2.314-.584,4.277,4.277,0,0,1-2.07-3.239c-.011-.284-.017-.567-.006-.845A4.27,4.27,0,0,1,7.327,5.15c.011.84-.023,1.679-.023,2.519a1.946,1.946,0,0,0-2.484,1.2,2.25,2.25,0,0,0-.079.913,1.931,1.931,0,0,0,1.985,1.628A1.906,1.906,0,0,0,8.3,10.5a1.309,1.309,0,0,0,.233-.6c.057-1.015.034-2.025.04-3.04.006-2.286-.006-4.566.011-6.846Z",
    transform: "translate(29.633 1419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pinterest-square-2",
    "data-name": "Icon awesome-pinterest-square",
    d: "M17.98,4.176V18.3a1.927,1.927,0,0,1-1.926,1.926H6.2a10.284,10.284,0,0,0,1.1-2.38c.12-.462.614-2.344.614-2.344a2.635,2.635,0,0,0,2.26,1.132c2.974,0,5.113-2.733,5.113-6.129A5.784,5.784,0,0,0,9.207,4.819c-4.254,0-6.51,2.854-6.51,5.964a4.423,4.423,0,0,0,2,3.817c.189.088.285.048.329-.132.032-.136.2-.807.273-1.116a.291.291,0,0,0-.068-.281A3.842,3.842,0,0,1,4.5,10.823,4.266,4.266,0,0,1,8.946,6.544a3.892,3.892,0,0,1,4.118,4.009c0,2.665-1.345,4.511-3.1,4.511A1.433,1.433,0,0,1,8.5,13.283,19.916,19.916,0,0,0,9.319,10c0-2.127-3.03-1.834-3.03,1a3.6,3.6,0,0,0,.293,1.465c-1.26,5.33-1.449,5.4-1.188,7.73l.088.032H1.926A1.927,1.927,0,0,1,0,18.3V4.176A1.927,1.927,0,0,1,1.926,2.25H16.054A1.927,1.927,0,0,1,17.98,4.176Z",
    transform: "translate(29 1365.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-snapchat-ghost-2",
    "data-name": "Icon awesome-snapchat-ghost",
    d: "M15.919,12.837c-.162.379-.849.657-2.1.851a5.845,5.845,0,0,0-.2.747.361.361,0,0,1-.378.276H13.23c-.293,0-.6-.135-1.211-.135a2.466,2.466,0,0,0-1.753.642,3.51,3.51,0,0,1-2.307.854,3.579,3.579,0,0,1-2.271-.854,2.463,2.463,0,0,0-1.753-.641,11.77,11.77,0,0,0-1.211.147.37.37,0,0,1-.387-.282,5.772,5.772,0,0,0-.2-.752c-.644-.1-2.1-.354-2.135-1a.331.331,0,0,1,.277-.345A4.691,4.691,0,0,0,3.463,9.665l.007-.016a.708.708,0,0,0,.077-.584c-.157-.371-.837-.5-1.124-.617-.739-.292-.842-.627-.8-.857a.8.8,0,0,1,1.028-.482,1.783,1.783,0,0,0,.734.2.636.636,0,0,0,.31-.068,9.3,9.3,0,0,1,.177-3.614A4.246,4.246,0,0,1,7.816,1.081l.315,0a4.216,4.216,0,0,1,3.949,2.544,9.3,9.3,0,0,1,.177,3.615.611.611,0,0,0,.268.067,1.862,1.862,0,0,0,.688-.195.843.843,0,0,1,.638,0h0a.647.647,0,0,1,.486.557c.006.3-.266.566-.806.78-.066.026-.146.052-.232.079-.305.1-.767.243-.892.538a.708.708,0,0,0,.077.584l.007.016a4.69,4.69,0,0,0,3.186,2.678A.34.34,0,0,1,15.919,12.837Z",
    transform: "translate(30 1463.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_domain_24px",
    d: "M12,7V3H2V21H22V7ZM6,19H4V17H6Zm0-4H4V13H6Zm0-4H4V9H6ZM6,7H4V5H6Zm4,12H8V17h2Zm0-4H8V13h2Zm0-4H8V9h2Zm0-4H8V5h2ZM20,19H12V17h2V15H12V13h2V11H12V9h8Zm-2-8H16v2h2Zm0,4H16v2h2Z",
    transform: "translate(26 1645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_search_24px",
    d: "M15.5,14h-.79l-.28-.27a6.51,6.51,0,1,0-.7.7l.27.28v.79l5,4.99L20.49,19Zm-6,0A4.5,4.5,0,1,1,14,9.5,4.494,4.494,0,0,1,9.5,14Z",
    transform: "translate(26 1595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_description_24px",
    d: "M14,2H6A2,2,0,0,0,4.01,4L4,20a2,2,0,0,0,1.99,2H18a2.006,2.006,0,0,0,2-2V8Zm2,16H8V16h8Zm0-4H8V12h8ZM13,9V3.5L18.5,9Z",
    transform: "translate(26 1543)",
    fill: "#9a8bf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_email_24px-2",
    "data-name": "ic_email_24px",
    d: "M18.648,4H3.85A1.847,1.847,0,0,0,2.009,5.85L2,16.949A1.855,1.855,0,0,0,3.85,18.8h14.8a1.855,1.855,0,0,0,1.85-1.85V5.85A1.855,1.855,0,0,0,18.648,4Zm0,3.7-7.4,4.625L3.85,7.7V5.85l7.4,4.625,7.4-4.625Z",
    transform: "translate(27 1776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_forum_24px",
    d: "M19.573,5.7h-1.85v8.324H5.7v1.85a.928.928,0,0,0,.925.925H16.8l3.7,3.7V6.625A.928.928,0,0,0,19.573,5.7Zm-3.7,5.549V2.925A.928.928,0,0,0,14.949,2H2.925A.928.928,0,0,0,2,2.925V15.874l3.7-3.7h9.249A.928.928,0,0,0,15.874,11.249Z",
    transform: "translate(27 1825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_email_24px-3",
    "data-name": "ic_email_24px",
    d: "M20,4H4A2,2,0,0,0,2.01,6L2,18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,20,4Zm0,4-8,5L4,8V6l8,5,8-5Z",
    transform: "translate(26 1727)",
    fill: "#f25a4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-remove-red-eye",
    "data-name": "Icon material-remove-red-eye",
    d: "M15,6.75a14.515,14.515,0,0,0-13.5,9.2,14.5,14.5,0,0,0,27,0A14.515,14.515,0,0,0,15,6.75Zm0,15.341a6.136,6.136,0,1,1,6.136-6.136A6.139,6.139,0,0,1,15,22.091Zm0-9.818a3.682,3.682,0,1,0,3.682,3.682A3.677,3.677,0,0,0,15,12.273Z",
    transform: "translate(23.5 360.25)",
    fill: "#fce535"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_653-2",
    "data-name": "Rectangle 653",
    width: 849,
    height: 327,
    rx: 10,
    transform: "translate(488 338)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_652)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_652-2",
    "data-name": "Rectangle 652",
    width: 352,
    height: 327,
    rx: 10,
    transform: "translate(106 338)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_266",
    "data-name": "Ligne 266",
    x1: 847.296,
    transform: "translate(488.602 501.5)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeLinecap: "square",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_267",
    "data-name": "Ligne 267",
    y1: 326.5,
    transform: "translate(758.938 338)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_268",
    "data-name": "Ligne 268",
    y1: 327,
    transform: "translate(1065.5 338)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_355-3",
    "data-name": "Rectangle 355",
    transform: "translate(106 258)",
    fill: "#fff",
    stroke: "#101221",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 603,
    height: 49,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 602,
    height: 48,
    rx: 9.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_1272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1272-2",
    "data-name": "Rectangle 1272",
    transform: "translate(738 258)",
    fill: "#fff",
    stroke: "#101221",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 603,
    height: 49,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 602,
    height: 48,
    rx: 9.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "S\\xE9lectionner_une_cat\\xE9gorie_produit",
    "data-name": "S\\xE9lectionner une cat\\xE9gorie produit",
    transform: "translate(126 287)",
    fill: "#101221",
    fontSize: 14,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S\xE9lectionner une cat\xE9gorie produit")), /*#__PURE__*/React.createElement("text", {
    id: "S\\xE9lectionner_un_produit",
    "data-name": "S\\xE9lectionner un produit",
    transform: "translate(758 287)",
    fill: "#101221",
    fontSize: 14,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S\xE9lectionner un produit")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-down-7",
    "data-name": "Icon awesome-chevron-down",
    d: "M3.687,12.9.513,9.723a.392.392,0,0,1,0-.554l.37-.37a.392.392,0,0,1,.554,0l2.527,2.515L6.491,8.8a.392.392,0,0,1,.554,0l.37.37a.392.392,0,0,1,0,.554L4.241,12.9A.392.392,0,0,1,3.687,12.9Z",
    transform: "translate(1313.102 273.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-down-8",
    "data-name": "Icon awesome-chevron-down",
    d: "M3.687,12.9.513,9.723a.392.392,0,0,1,0-.554l.37-.37a.392.392,0,0,1,.554,0l2.527,2.515L6.491,8.8a.392.392,0,0,1,.554,0l.37.37a.392.392,0,0,1,0,.554L4.241,12.9A.392.392,0,0,1,3.687,12.9Z",
    transform: "translate(679.036 273.316)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Nombre_de_commandes",
    "data-name": "Nombre de commandes",
    transform: "translate(623 379.767)",
    fill: "#22222e",
    fontSize: 14,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -86.24,
    y: 0
  }, "Nombre de commandes")), /*#__PURE__*/React.createElement("text", {
    id: "Produits_achet\\xE9s",
    "data-name": "Produits achet\\xE9s",
    transform: "translate(623 543.104)",
    fill: "#22222e",
    fontSize: 14,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -58.779,
    y: 0
  }, "Produits achet\xE9s")), /*#__PURE__*/React.createElement("text", {
    id: "Taux_de_conversion",
    "data-name": "Taux de conversion",
    transform: "translate(907.5 379.767)",
    fill: "#22222e",
    fontSize: 14,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -67.102,
    y: 0
  }, "Taux de conversion")), /*#__PURE__*/React.createElement("text", {
    id: "Panier_moyen_HT",
    "data-name": "Panier moyen HT",
    transform: "translate(907.5 543.104)",
    fill: "#22222e",
    fontSize: 14,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -60.466,
    y: 0
  }, "Panier moyen HT")), /*#__PURE__*/React.createElement("text", {
    id: "Fr\\xE9quence_d_achat",
    "data-name": "Fr\\xE9quence d\\u2019achat",
    transform: "translate(1195 379.767)",
    fill: "#22222e",
    fontSize: 14,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -65.583,
    y: 0
  }, "Fr\xE9quence d\u2019achat")), /*#__PURE__*/React.createElement("text", {
    id: "Tx._De_client_r\\xE9curent",
    "data-name": "Tx. De client r\\xE9curent",
    transform: "translate(1195 543.104)",
    fill: "#22222e",
    fontSize: 14,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -74.095,
    y: 0
  }, "Tx. De client r\xE9curent")), /*#__PURE__*/React.createElement("text", {
    id: "_156",
    "data-name": 156,
    transform: "translate(623 425.767)",
    fill: "#101221",
    fontSize: 28,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.736,
    y: 0
  }, "156")), /*#__PURE__*/React.createElement("text", {
    id: "_345",
    "data-name": 345,
    transform: "translate(623 589.104)",
    fill: "#101221",
    fontSize: 28,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.236,
    y: 0
  }, "345")), /*#__PURE__*/React.createElement("text", {
    id: "_5_30_",
    "data-name": "5,30%",
    transform: "translate(907.5 425.767)",
    fill: "#101221",
    fontSize: 28,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -42.21,
    y: 0
  }, "5,30%")), /*#__PURE__*/React.createElement("text", {
    id: "_78_69_",
    "data-name": "78,69 \\u20AC",
    transform: "translate(907.5 589.104)",
    fill: "#101221",
    fontSize: 28,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -54.586,
    y: 0
  }, "78,69 \u20AC")), /*#__PURE__*/React.createElement("text", {
    id: "_2_4",
    "data-name": "2,4",
    transform: "translate(1195 425.767)",
    fill: "#101221",
    fontSize: 28,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.714,
    y: 0
  }, "2,4")), /*#__PURE__*/React.createElement("text", {
    id: "_27_50_",
    "data-name": "27,50%",
    transform: "translate(1195 589.104)",
    fill: "#101221",
    fontSize: 28,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -50.008,
    y: 0
  }, "27,50%")), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_748",
    "data-name": "Groupe 748",
    transform: "translate(593 451.767)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 61,
    height: 22,
    rx: 5,
    fill: "#87e683"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_356",
    "data-name": "Groupe 356",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2_4_",
    "data-name": "2,4%",
    transform: "translate(16 12)",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2,4%")), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_3",
    "data-name": "Polygone 3",
    d: "M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(0 5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_914",
    "data-name": "Groupe 914",
    transform: "translate(593 615.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-2",
    "data-name": "Rectangle 680",
    width: 61,
    height: 22,
    rx: 5,
    fill: "#87e683"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_356-2",
    "data-name": "Groupe 356",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2_4_2",
    "data-name": "2,4%",
    transform: "translate(16 12)",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2,4%")), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_3-2",
    "data-name": "Polygone 3",
    d: "M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(0 5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_905",
    "data-name": "Groupe 905",
    transform: "translate(877.5 451.767)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-3",
    "data-name": "Rectangle 680",
    width: 61,
    height: 22,
    rx: 5,
    fill: "#87e683"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_356-3",
    "data-name": "Groupe 356",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2_4_3",
    "data-name": "2,4%",
    transform: "translate(16 12)",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2,4%")), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_3-3",
    "data-name": "Polygone 3",
    d: "M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(0 5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_910",
    "data-name": "Groupe 910",
    transform: "translate(877.5 615.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-4",
    "data-name": "Rectangle 680",
    width: 61,
    height: 22,
    rx: 5,
    fill: "#87e683"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_356-4",
    "data-name": "Groupe 356",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2_4_4",
    "data-name": "2,4%",
    transform: "translate(16 12)",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2,4%")), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_3-4",
    "data-name": "Polygone 3",
    d: "M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(0 5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_907",
    "data-name": "Groupe 907",
    transform: "translate(1165 451.767)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-5",
    "data-name": "Rectangle 680",
    width: 61,
    height: 22,
    rx: 5,
    fill: "#87e683"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_356-5",
    "data-name": "Groupe 356",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2_4_5",
    "data-name": "2,4%",
    transform: "translate(16 12)",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2,4%")), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_3-5",
    "data-name": "Polygone 3",
    d: "M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(0 5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_909",
    "data-name": "Groupe 909",
    transform: "translate(1165 615.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-6",
    "data-name": "Rectangle 680",
    width: 61,
    height: 22,
    rx: 5,
    fill: "#87e683"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_356-6",
    "data-name": "Groupe 356",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2_4_6",
    "data-name": "2,4%",
    transform: "translate(16 12)",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2,4%")), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_3-6",
    "data-name": "Polygone 3",
    d: "M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(0 5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_294",
    "data-name": "Groupe 294",
    transform: "translate(716 358.164)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-solid",
    d: "M3.006,39.825H2.4V35.617a.6.6,0,0,0-.6-.6H.6a.6.6,0,0,0-.6.6.587.587,0,0,0,.6.584h.6v3.607H.6a.6.6,0,1,0,0,1.2h2.4a.6.6,0,0,0,.6-.6A.586.586,0,0,0,3.006,39.825ZM1.8,33.813a.9.9,0,1,0-.9-.9A.9.9,0,0,0,1.8,33.813Z",
    transform: "translate(5.695 -29.51)",
    fill: "#656565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_913",
    "data-name": "Groupe 913",
    transform: "translate(685 521.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154-2",
    "data-name": "Ellipse 154",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-solid-2",
    "data-name": "info-solid",
    d: "M3.006,39.825H2.4V35.617a.6.6,0,0,0-.6-.6H.6a.6.6,0,0,0-.6.6.587.587,0,0,0,.6.584h.6v3.607H.6a.6.6,0,1,0,0,1.2h2.4a.6.6,0,0,0,.6-.6A.586.586,0,0,0,3.006,39.825ZM1.8,33.813a.9.9,0,1,0-.9-.9A.9.9,0,0,0,1.8,33.813Z",
    transform: "translate(5.695 -29.51)",
    fill: "#656565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_906",
    "data-name": "Groupe 906",
    transform: "translate(981.5 358.164)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154-3",
    "data-name": "Ellipse 154",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-solid-3",
    "data-name": "info-solid",
    d: "M3.006,39.825H2.4V35.617a.6.6,0,0,0-.6-.6H.6a.6.6,0,0,0-.6.6.587.587,0,0,0,.6.584h.6v3.607H.6a.6.6,0,1,0,0,1.2h2.4a.6.6,0,0,0,.6-.6A.586.586,0,0,0,3.006,39.825ZM1.8,33.813a.9.9,0,1,0-.9-.9A.9.9,0,0,0,1.8,33.813Z",
    transform: "translate(5.695 -29.51)",
    fill: "#656565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_911",
    "data-name": "Groupe 911",
    transform: "translate(978.5 521.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154-4",
    "data-name": "Ellipse 154",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-solid-4",
    "data-name": "info-solid",
    d: "M3.006,39.825H2.4V35.617a.6.6,0,0,0-.6-.6H.6a.6.6,0,0,0-.6.6.587.587,0,0,0,.6.584h.6v3.607H.6a.6.6,0,1,0,0,1.2h2.4a.6.6,0,0,0,.6-.6A.586.586,0,0,0,3.006,39.825ZM1.8,33.813a.9.9,0,1,0-.9-.9A.9.9,0,0,0,1.8,33.813Z",
    transform: "translate(5.695 -29.51)",
    fill: "#656565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_908",
    "data-name": "Groupe 908",
    transform: "translate(1268 358.164)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154-5",
    "data-name": "Ellipse 154",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-solid-5",
    "data-name": "info-solid",
    d: "M3.006,39.825H2.4V35.617a.6.6,0,0,0-.6-.6H.6a.6.6,0,0,0-.6.6.587.587,0,0,0,.6.584h.6v3.607H.6a.6.6,0,1,0,0,1.2h2.4a.6.6,0,0,0,.6-.6A.586.586,0,0,0,3.006,39.825ZM1.8,33.813a.9.9,0,1,0-.9-.9A.9.9,0,0,0,1.8,33.813Z",
    transform: "translate(5.695 -29.51)",
    fill: "#656565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_912",
    "data-name": "Groupe 912",
    transform: "translate(1276 521.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154-6",
    "data-name": "Ellipse 154",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-solid-6",
    "data-name": "info-solid",
    d: "M3.006,39.825H2.4V35.617a.6.6,0,0,0-.6-.6H.6a.6.6,0,0,0-.6.6.587.587,0,0,0,.6.584h.6v3.607H.6a.6.6,0,1,0,0,1.2h2.4a.6.6,0,0,0,.6-.6A.586.586,0,0,0,3.006,39.825ZM1.8,33.813a.9.9,0,1,0-.9-.9A.9.9,0,0,0,1.8,33.813Z",
    transform: "translate(5.695 -29.51)",
    fill: "#656565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_915",
    "data-name": "Groupe 915",
    transform: "translate(252 578.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-7",
    "data-name": "Rectangle 680",
    width: 61,
    height: 22,
    rx: 5,
    fill: "#87e683"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_356-7",
    "data-name": "Groupe 356",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2_4_7",
    "data-name": "2,4%",
    transform: "translate(16 12)",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2,4%")), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_3-7",
    "data-name": "Polygone 3",
    d: "M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(0 5)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Chiffre_d_Affaires_HT",
    "data-name": "Chiffre d\\u2019Affaires HT",
    transform: "translate(196 495.001)",
    fill: "#101221",
    fontSize: 14,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Chiffre d\u2019Affaires HT")), /*#__PURE__*/React.createElement("text", {
    id: "_12_275_50_",
    "data-name": "12 275,50 \\u20AC",
    transform: "translate(282 551.001)",
    fill: "#101221",
    fontSize: 35,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -93.923,
    y: 0
  }, "12 275,50 \u20AC")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_355-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355-4",
    "data-name": "Rectangle 355",
    width: 533,
    height: 412,
    rx: 10,
    transform: "translate(804 786)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Cat\\xE9gorie_produit",
    "data-name": "Cat\\xE9gorie produit",
    transform: "translate(867.156 824)",
    fill: "#22222e",
    fontSize: 16,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cat\xE9gorie produit")), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_111",
    "data-name": "Ligne 111",
    x2: 476.845,
    transform: "translate(830.656 845.5)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "CAT_1",
    "data-name": "CAT 1",
    transform: "translate(855 896)",
    fill: "#101221",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CAT 1")), /*#__PURE__*/React.createElement("text", {
    id: "CAT_2",
    "data-name": "CAT 2",
    transform: "translate(855 934)",
    fill: "#101221",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CAT 2")), /*#__PURE__*/React.createElement("text", {
    id: "CAT_3",
    "data-name": "CAT 3",
    transform: "translate(855 972)",
    fill: "#101221",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CAT 3")), /*#__PURE__*/React.createElement("text", {
    id: "CAT_4",
    "data-name": "CAT 4",
    transform: "translate(855 1010)",
    fill: "#101221",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CAT 4")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(836 888)",
    fill: "#9fd8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(836 926)",
    fill: "#1b7afa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(836 963)",
    fill: "#f4994f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(836 1001)",
    fill: "#64d691"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Photoshop-100-27.03_",
    "data-name": "Photoshop-100-27.03%",
    d: "M17.224,0H158.557a141.333,141.333,0,0,1-47.683,105.852A141.333,141.333,0,0,1,0,140.279Z",
    transform: "translate(1138.502 1039.886) rotate(-90)",
    fill: "#9fd8f9",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Illustrator-90-24.32_",
    "data-name": "Illustrator-90-24.32%",
    d: "M141.338,9.859,124.114,150.138A141.333,141.333,0,0,1,.349,0Z",
    transform: "translate(1128.643 1164) rotate(-90)",
    fill: "#64d691",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Xd-80-21.62_",
    "data-name": "Xd-80-21.62%",
    d: "M140.989,139.593,0,129.734A141.333,141.333,0,0,1,118.879,0Z",
    transform: "translate(998.91 1163.65) rotate(-90)",
    fill: "#f4994f",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "data4-100-27.03_",
    "data-name": "data4-100-27.03%",
    d: "M22.109,141.334,0,1.741A141.333,141.333,0,0,1,163.442,141.334Z",
    transform: "translate(997.168 1044.771) rotate(-90)",
    fill: "#1b7afa",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 69.831,
    cy: 69.831,
    rx: 69.831,
    ry: 69.831,
    transform: "translate(1069.447 952.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_clipboard-text",
    "data-name": "vuesax/linear/clipboard-text",
    transform: "translate(721 554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H7",
    transform: "translate(116 264.2)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H4.38",
    transform: "translate(116 268.2)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2,4H6C8,4,8,3,8,2,8,0,7,0,6,0H2C1,0,0,0,0,2S1,4,2,4Z",
    transform: "translate(116 254)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M13,0c3.33.18,5,1.41,5,5.98v6c0,4-1,6-6,6H6c-5,0-6-2-6-6v-6C0,1.42,1.67.18,5,0",
    transform: "translate(111 256.02)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(108 252)",
    fill: "none",
    opacity: 0
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462-2",
    "data-name": "Rectangle 462",
    width: 668,
    height: 412,
    rx: 10,
    transform: "translate(106 786)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Flux_des_commandes_recettes",
    "data-name": "Flux des commandes & recettes",
    transform: "translate(183.558 824.25)",
    fill: "#101221",
    fontSize: 16,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Flux des commandes &amp; recettes")), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_159",
    "data-name": "Ligne 159",
    x2: 606.704,
    transform: "translate(134.146 846.75)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_81",
    "data-name": "Groupe 81",
    transform: "translate(205.124 879.218)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_56",
    "data-name": "Ligne 56",
    y2: 218.216,
    transform: "translate(0)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_57",
    "data-name": "Ligne 57",
    x2: 454.889,
    transform: "translate(0 218.216)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_58",
    "data-name": "Ligne 58",
    x2: 454.889,
    transform: "translate(0 181.847)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_59",
    "data-name": "Ligne 59",
    x2: 454.889,
    transform: "translate(0 145.478)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_60",
    "data-name": "Ligne 60",
    x2: 454.889,
    transform: "translate(0 109.108)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_61",
    "data-name": "Ligne 61",
    x2: 454.889,
    transform: "translate(0 72.739)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_62",
    "data-name": "Ligne 62",
    x2: 454.889,
    transform: "translate(0 36.369)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_63",
    "data-name": "Ligne 63",
    x2: 454.889,
    transform: "translate(0)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(170 1077)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    id: "_0-2",
    "data-name": 0,
    transform: "translate(695 1077)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    id: "Jan",
    transform: "translate(205 1113)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Jan")), /*#__PURE__*/React.createElement("text", {
    id: "Feb",
    transform: "translate(264 1113)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Feb")), /*#__PURE__*/React.createElement("text", {
    id: "March",
    transform: "translate(320 1113)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "March")), /*#__PURE__*/React.createElement("text", {
    id: "April",
    transform: "translate(387 1113)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "April")), /*#__PURE__*/React.createElement("text", {
    id: "May",
    transform: "translate(451 1113)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "May")), /*#__PURE__*/React.createElement("text", {
    id: "June",
    transform: "translate(515 1113)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "June")), /*#__PURE__*/React.createElement("text", {
    id: "July",
    transform: "translate(580 1113)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "July")), /*#__PURE__*/React.createElement("text", {
    id: "Aug",
    transform: "translate(638 1113)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Aug")), /*#__PURE__*/React.createElement("text", {
    id: "_200",
    "data-name": 200,
    transform: "translate(166 1015)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "200")), /*#__PURE__*/React.createElement("text", {
    id: "Recettes_TTC",
    "data-name": "Recettes TTC",
    transform: "translate(132 1031) rotate(-90)",
    fill: "#22222e",
    fontSize: 10,
    fontFamily: "Montserrat-MediumItalic, Montserrat",
    fontWeight: 500,
    fontStyle: "italic",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "Recettes TTC")), /*#__PURE__*/React.createElement("text", {
    id: "Commandes",
    transform: "translate(742.719 991.5) rotate(-90)",
    fill: "#22222e",
    fontSize: 10,
    fontFamily: "Montserrat-MediumItalic, Montserrat",
    fontWeight: 500,
    fontStyle: "italic",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.865,
    y: 0
  }, "Commandes")), /*#__PURE__*/React.createElement("text", {
    id: "_50",
    "data-name": 50,
    transform: "translate(691 1015)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("text", {
    id: "_400",
    "data-name": 400,
    transform: "translate(166 946)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "400")), /*#__PURE__*/React.createElement("text", {
    id: "_100",
    "data-name": 100,
    transform: "translate(691 946)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100")), /*#__PURE__*/React.createElement("text", {
    id: "_600",
    "data-name": 600,
    transform: "translate(166 888)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "600")), /*#__PURE__*/React.createElement("text", {
    id: "_150",
    "data-name": 150,
    transform: "translate(691 888)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "150")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 22,
    height: 135,
    transform: "translate(205 962)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 29,
    height: 80,
    transform: "translate(261 1017)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 29,
    height: 110,
    transform: "translate(325 987)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 29,
    height: 85,
    transform: "translate(387 1012)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 29,
    height: 68,
    transform: "translate(451 1029)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 29,
    height: 85,
    transform: "translate(515 1012)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 28,
    height: 143,
    transform: "translate(578 954)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 20,
    height: 95,
    transform: "translate(640 1002)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M221.768,760.54s1.874-2.678,2.593-3.786c5.705-8.789,40.865-61.38,64.6-61.38,25.97,0,48.477,32.1,64,32.1s37.377-31.094,62.908-32.1,48.719,63.068,67.739,62.954,51.968,30.141,64.572,30.141,38.584-59,64.573-61,62.218-30.537,65.573-32.1",
    transform: "translate(-15.908 229.857)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_916",
    "data-name": "Groupe 916",
    transform: "translate(-117 14)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Recettes_TTC-2",
    "data-name": "Recettes TTC",
    transform: "translate(459 1148)",
    fill: "#101221",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Recettes TTC")), /*#__PURE__*/React.createElement("text", {
    id: "Commandes-2",
    "data-name": "Commandes",
    transform: "translate(596 1148)",
    fill: "#101221",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Commandes")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_732",
    "data-name": "Rectangle 732",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(439 1139)",
    fill: "#1b7afa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    width: 10,
    height: 10,
    rx: 3,
    transform: "translate(576 1139)",
    fill: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(134.146 806.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H27.46",
    transform: "translate(2.606 22.917)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,2.083V20.834H5.864V2.083C5.864.938,5.277,0,3.518,0H2.346C.586,0,0,.938,0,2.083Z",
    transform: "translate(13.357 2.084)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M0,2.083v12.5H5.212V2.083A1.865,1.865,0,0,0,3.127,0H2.085A1.865,1.865,0,0,0,0,2.083Z",
    transform: "translate(3.909 8.335)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M0,2.083V9.375H5.212V2.083A1.865,1.865,0,0,0,3.127,0H2.085A1.865,1.865,0,0,0,0,2.083Z",
    transform: "translate(23.457 13.542)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-10",
    "data-name": "Vector",
    d: "M0,0H31.273V25H0Z",
    fill: "none",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_679)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679-2",
    "data-name": "Rectangle 679",
    width: 1234.813,
    height: 152,
    rx: 10,
    transform: "translate(106 1308.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_850",
    "data-name": "Groupe 850",
    transform: "translate(487.907 1308.232)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_242",
    "data-name": "Ligne 242",
    y2: 152.517,
    fill: "none",
    stroke: "#d9d9d9",
    strokeLinecap: "square",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_243",
    "data-name": "Ligne 243",
    y2: 152.517,
    transform: "translate(470.65)",
    fill: "none",
    stroke: "#d9d9d9",
    strokeLinecap: "square",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "Paniers_abandonn\\xE9s-2",
    "data-name": "Paniers abandonn\\xE9s",
    transform: "translate(280.5 1343.5)",
    fill: "#22222e",
    fontSize: 14,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -71.953,
    y: 0
  }, "Paniers abandonn\xE9s")), /*#__PURE__*/React.createElement("text", {
    id: "Visites_avec_Panier_abandonn\\xE9",
    "data-name": "Visites avec Panier abandonn\\xE9",
    transform: "translate(1138.813 1343.5)",
    fill: "#22222e",
    fontSize: 14,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -107.03,
    y: 0
  }, "Visites avec Panier abandonn\xE9")), /*#__PURE__*/React.createElement("text", {
    id: "_45",
    "data-name": 45,
    transform: "translate(280.5 1389.5)",
    fill: "#101221",
    fontSize: 28,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.948,
    y: 0
  }, "45")), /*#__PURE__*/React.createElement("text", {
    id: "_5_3_",
    "data-name": "5,3%",
    transform: "translate(1138.813 1389.5)",
    fill: "#101221",
    fontSize: 28,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.564,
    y: 0
  }, "5,3%")), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_748-2",
    "data-name": "Groupe 748",
    transform: "translate(250.5 1415.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-8",
    "data-name": "Rectangle 680",
    width: 61,
    height: 22,
    rx: 5,
    fill: "#87e683"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_356-8",
    "data-name": "Groupe 356",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2_4_8",
    "data-name": "2,4%",
    transform: "translate(16 12)",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2,4%")), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_3-8",
    "data-name": "Polygone 3",
    d: "M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(0 5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_830",
    "data-name": "Groupe 830",
    transform: "translate(1108.813 1415.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-9",
    "data-name": "Rectangle 680",
    width: 61,
    height: 22,
    rx: 5,
    fill: "#87e683"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_356-9",
    "data-name": "Groupe 356",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2_4_9",
    "data-name": "2,4%",
    transform: "translate(16 12)",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2,4%")), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_3-9",
    "data-name": "Polygone 3",
    d: "M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(0 5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_294-2",
    "data-name": "Groupe 294",
    transform: "translate(356.5 1321.896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154-7",
    "data-name": "Ellipse 154",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-solid-7",
    "data-name": "info-solid",
    d: "M3.006,39.825H2.4V35.617a.6.6,0,0,0-.6-.6H.6a.6.6,0,0,0-.6.6.587.587,0,0,0,.6.584h.6v3.607H.6a.6.6,0,1,0,0,1.2h2.4a.6.6,0,0,0,.6-.6A.586.586,0,0,0,3.006,39.825ZM1.8,33.813a.9.9,0,1,0-.9-.9A.9.9,0,0,0,1.8,33.813Z",
    transform: "translate(5.695 -29.51)",
    fill: "#656565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_851",
    "data-name": "Groupe 851",
    transform: "translate(655.413 1321.896)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Total_revenu_HT_laiss\\xE9_dans_le_panier",
    "data-name": "Total revenu HT laiss\\xE9 dans le panier",
    transform: "translate(60 21.604)",
    fill: "#22222e",
    fontSize: 14,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -126.462,
    y: 0
  }, "Total revenu HT laiss\xE9 dans le panier")), /*#__PURE__*/React.createElement("text", {
    id: "_3_541_05_",
    "data-name": "3 541,05 \\u20AC",
    transform: "translate(60 67.604)",
    fill: "#101221",
    fontSize: 28,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -72.128,
    y: 0
  }, "3 541,05 \u20AC")), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_828",
    "data-name": "Groupe 828",
    transform: "translate(30 93.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-10",
    "data-name": "Rectangle 680",
    width: 61,
    height: 22,
    rx: 5,
    fill: "#87e683"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_356-10",
    "data-name": "Groupe 356",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2_4_10",
    "data-name": "2,4%",
    transform: "translate(16 12)",
    fontSize: 12,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2,4%")), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_3-10",
    "data-name": "Polygone 3",
    d: "M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z",
    transform: "translate(0 5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_829",
    "data-name": "Groupe 829",
    transform: "translate(190)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154-8",
    "data-name": "Ellipse 154",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-solid-8",
    "data-name": "info-solid",
    d: "M3.006,39.825H2.4V35.617a.6.6,0,0,0-.6-.6H.6a.6.6,0,0,0-.6.6.587.587,0,0,0,.6.584h.6v3.607H.6a.6.6,0,1,0,0,1.2h2.4a.6.6,0,0,0,.6-.6A.586.586,0,0,0,3.006,39.825ZM1.8,33.813a.9.9,0,1,0-.9-.9A.9.9,0,0,0,1.8,33.813Z",
    transform: "translate(5.695 -29.51)",
    fill: "#656565"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_831",
    "data-name": "Groupe 831",
    transform: "translate(1251.813 1321.896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154-9",
    "data-name": "Ellipse 154",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info-solid-9",
    "data-name": "info-solid",
    d: "M3.006,39.825H2.4V35.617a.6.6,0,0,0-.6-.6H.6a.6.6,0,0,0-.6.6.587.587,0,0,0,.6.584h.6v3.607H.6a.6.6,0,1,0,0,1.2h2.4a.6.6,0,0,0,.6-.6A.586.586,0,0,0,3.006,39.825ZM1.8,33.813a.9.9,0,1,0-.9-.9A.9.9,0,0,0,1.8,33.813Z",
    transform: "translate(5.695 -29.51)",
    fill: "#656565"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-store-2",
    "data-name": "Icon awesome-store",
    d: "M25.414,5.007,22.675.633A1.351,1.351,0,0,0,21.531,0H4.476A1.351,1.351,0,0,0,3.332.633L.593,5.007a3.766,3.766,0,0,0,2.482,5.758,4.387,4.387,0,0,0,.578.038,4.168,4.168,0,0,0,3.115-1.4,4.172,4.172,0,0,0,6.231,0,4.172,4.172,0,0,0,6.231,0,4.182,4.182,0,0,0,3.115,1.4,4.34,4.34,0,0,0,.578-.038A3.762,3.762,0,0,0,25.414,5.007Zm-3.061,7.151A5.356,5.356,0,0,1,21.109,12V16.21H4.9V12a5.592,5.592,0,0,1-1.245.16,5.7,5.7,0,0,1-.76-.051,5.309,5.309,0,0,1-.692-.152v8.308a1.349,1.349,0,0,0,1.351,1.351H22.464a1.349,1.349,0,0,0,1.351-1.351V11.955a4.31,4.31,0,0,1-.692.152A5.871,5.871,0,0,1,22.354,12.158Z",
    transform: "translate(128.996 111.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1052",
    "data-name": "Groupe 1052",
    transform: "translate(32.116 -220.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "money-recive",
    transform: "translate(225 622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-11",
    "data-name": "Vector",
    d: "M50.639,25.32A25.32,25.32,0,1,1,25.32,0",
    transform: "translate(5.064 5.064)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-12",
    "data-name": "Vector",
    d: "M0,0V10.128H10.128",
    transform: "translate(47.043 2.596)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-13",
    "data-name": "Vector",
    d: "M12.66,0,0,12.66",
    transform: "translate(47.043 0.064)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-14",
    "data-name": "Vector",
    d: "M0,0H60.767V60.767H0Z",
    transform: "translate(0)",
    fill: "none",
    opacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2226",
    "data-name": "Trac\\xE9 2226",
    d: "M10.868,11.96A9.656,9.656,0,0,1,1.332,5.231h11.6V3.743H.96a12.149,12.149,0,0,1-.1-1.589A12.149,12.149,0,0,1,.96.565H12.93V-.923H1.332a9.656,9.656,0,0,1,9.536-6.729,9.357,9.357,0,0,1,6.966,2.807l1.623-1.589a11.562,11.562,0,0,0-8.724-3.449c-5.985,0-10.685,3.652-12,8.961H-5.194V.565h3.652a12.149,12.149,0,0,0-.1,1.589,12.149,12.149,0,0,0,.1,1.589H-5.194V5.231h3.922c1.319,5.309,6.019,8.961,12,8.961a11.586,11.586,0,0,0,8.724-3.483L17.833,9.12A9.262,9.262,0,0,1,10.868,11.96Z",
    transform: "translate(248.196 650.379)",
    fill: "none",
    stroke: "#1b7afa",
    strokeWidth: 2.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerceDemo);
export default __webpack_public_path__ + "static/media/E-Commerce-demo.de3233a865e56f16803910b2ef27b7b7.svg";
export { ForwardRef as ReactComponent };